import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutofocusWithConditionDirective } from './auto-focus-with-condition.directive';


@NgModule({
  declarations: [AutofocusWithConditionDirective],
  imports: [CommonModule],
  exports: [AutofocusWithConditionDirective]
})
export class AutoFocusWithConditionDirectiveModule {}

